__turbopack_context__.v({
  "className": "bebas_neue_eec307dc-module__8NZH0q__className",
  "variable": "bebas_neue_eec307dc-module__8NZH0q__variable",
});
